export default[
    {
        path: '/tabelapreco/cadastro',
        name: 'cadastro tabela de preço', 
        component: () => import(/* webpackChunkName: "Login" */ './page/cadastro.vue')
    },
    {
        path: '/tabelapreco/lista',
        name: 'lista da tabela de preço', 
        component: () => import(/* webpackChunkName: "Login" */ './page/lista.vue')
    },
    {
        path: '/tabelapreco/editar/:id',
        name: 'editar tabela de preço', 
        component: () => import(/* webpackChunkName: "Login" */ './page/editar.vue')
    },
]